_collow.components.AdminAddUsers = class AdminAddUsers extends (
  _collow.components.Base
) {
  root;
  elements;
  params;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.getGroups()
    this.listen(root, "submit", this.submitAddUser);
    this.listen(document, "_collow-errorbox-active", this.errorboxActive);
    this.maxUsers = JSON.parse(window.localStorage.getItem('whitelabelFeatures')).max_users;

  }

  getGroups = async () => {
    const page = window.document.body
    page.classList.add("loading")

    const response = await fetch(this.params.path + "/admin/group/all", {
      method: "GET",
        headers: {
          Authorization: window.localStorage.getItem("token"),
        },
    });
    if (!response.ok) {
      console.error("Unable to fetch groups - msg: " + response)
    }
    const list_all_groups = await response.json()
    page.classList.remove("loading")

    this.allGroups = list_all_groups;
    this.displayGroupList(list_all_groups);
  }

  displayGroupList = (groups) => {
    const groupUL = this.elements.groupUl;
    groupUL.textContent = '';

    groups.forEach(group => {
      const groupName = group.name
      const tableRow = document.createRange().createContextualFragment(`<li class="table-element">
        <input class="table-checkbox" type="checkbox" id="groups" name="groups" value="${groupName}"> <label for="${groupName}">${groupName}</label>
        </li>`);
      groupUL.append(tableRow);
    })
  };

  /** Listen to add users, get form data and send this to backend.
   */
  submitAddUser = (e) => {
    e.preventDefault();
    this.addUser(new FormData(this.root))
  }

  addUser = (formdata) => {
    fetch(this.params.path + "/admin/user", {
      method: "post",
      body: formdata,
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    }) 
      .then(async (res) => {
        const resJson = await res.json();
        if (res.status === 403) {
          // Display the toaster notification for 403 error
          _collow.Notify.error(this.params.maxuserlimitmessage, { actionLabel: this.params.visitsupport, href: this.params.supportlink });
        }
        if (!res.ok) throw resJson;
        
        this.listen(this.root, "change", () => {
          this.elements.succes.setAttribute("hidden", "");
        });
        await this.updateUserCount(); // Update the user count after adding a user
        _collow.Notify.success(this.params.success)

      })
      .catch((err) => {
        console.error(err)
        if (err.detail?.error_code == 'user_email-in-use') {
        _collow.Notify.error(this.params.erroremailinuse) 
      } else {
        _collow.Notify.error(this.params.errorgeneral)
      }})
  }

  updateUserCount = async () => {
    try {
      const response = await fetch(this.params.path + "/admin/user/count", {
        method: "get",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      if (!response.ok) throw new Error('Failed to get user count');

      let userCount = parseInt(await response.json(), 10);

      if (userCount == Math.floor(this.maxUsers * 0.8)) { 
        localStorage.setItem('USER_LIMIT_FLAG_80', 'true');
      } else {
        localStorage.removeItem('USER_LIMIT_FLAG_80');
      }

      if (userCount == this.maxUsers) {
        localStorage.setItem('USER_LIMIT_FLAG', 'true');
      } else {
        localStorage.removeItem('USER_LIMIT_FLAG');
      }
    } catch (error) {
      console.error('Error updating user count:', error);
    }
  }
};